import type { ChatMessage } from "../types";

interface BubbleProps {
  role: ChatMessage["role"];
  content: string;
  ts?: string;
}

export function Bubble({ role, content, ts }: BubbleProps) {
  const cls = role === "user" ? "bubble bubble--user" : "bubble bubble--bot";
  return (
    <div class={cls}>
      {content}
      {ts && <span class="bubble-ts">{ts}</span>}
    </div>
  );
}

export function SystemRow({ content, ts }: { content: string; ts?: string }) {
  return (
    <div class="sys-row">
      <span class="sys-row-icon">⚠</span>
      <span>{content}{ts ? ` · ${ts}` : ""}</span>
    </div>
  );
}
